module.exports = __webpack_public_path__ + "img/xgxz_common.e111c659.png";